module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('div', {
    staticClass: "row column card p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Parking Groups"), _c('SelectizeParkingGroup', {
    ref: "select",
    attrs: {
      "maxItems": null
    },
    on: {
      "optionSelected": _vm.add,
      "optionRemoved": _vm.remove
    }
  })], 1), _c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "componentType": "federationList",
      "selectableList": true,
      "resultsPerPage": 5
    },
    model: {
      value: (_vm.selected.delete),
      callback: function($$v) {
        _vm.$set(_vm.selected, "delete", $$v)
      },
      expression: "selected.delete"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18f1c556!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/FederationParkingGroupsEdit.vue
// module id = 2295
// module chunks = 1